module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#eth"
    }
  }, [_vm._v("Ethnomusicology Multimedia Series Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/translation#lan"
    }
  }, [_vm._v("Note on Language and Transliteration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Azerbaijani Musical Nationalism during the Pre-Soviet and Soviet Eras")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Pioneers of the New Azerbaijani Musical Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" The Russian-Soviet Factor: Facilitating or Disrupting Synthesis?")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" The Beginning of the National Style: 1900–the 1930s")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Growing Maturity: 1940–the Early 1960s")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" The Spirit of Experimentalism: Since the 1960s")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Songwriters")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(" Jazz "), _c('em', [_vm._v("Mugham")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v(" Leaving the Post-Soviet Era Behind")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v(" “"), _c('em', [_vm._v("Mugham")]), _vm._v(" Opera” of the Silk Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0